/** Permanent notice strip (GDD §6.4). Uses a status role so assistive tech announces it once. */
export function showNotice(root: HTMLElement, text: string): void {
  let notice = root.querySelector<HTMLElement>('.notice');
  if (!notice) {
    notice = document.createElement('p');
    notice.className = 'notice';
    notice.setAttribute('role', 'status');
    root.append(notice);
  }
  notice.textContent = text;
}
